import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import Head from '../../components/head';
import { FranchiseeProvider } from '../../context/Franchisee';
import { Container, Row, Col, Button, Toast, ListGroup } from 'react-bootstrap';
import Section from '../../components/Section';
import GratuitySelection from '../../components/GratuitySelection';
import ContextComponent from '../../components/ContextComponent';
import axios from 'axios';
import { useRouter } from 'next/router';
import Link from 'next/link';
import moment from 'moment';
import firebase from 'firebase';
export type AppointmentData = {
  appointmentId: number;
};
import BookingPaymentGratuity from '../../components/BookingPaymentGratuity';
import { PaymentProvider } from '../../context/Payment';
import * as Sentry from '@sentry/node';
import OpenGraphTitle from '../../components/OpenGraphTitle';
import OpenGraphDescription from '../../components/OpenGraphDescription';
import ToastWrapper from '../../components/ToastWrapper';
import database from '../../SDKs/firebase/firebase';
import { datadogRum } from '@datadog/browser-rum';

interface CustomerData {
  customerAddressLineOne: string;
  franchiseeName: string;
  customerFirstName: string;
  customerAddressLineTwo: string;
  franchiseeState: string;
  appointmentPrice: string;
  appointmentServiceFee: string;
  appointmentTax: string;
  appointmentServicesTotal: string;
  customerId: number;
  appointmentDate: string;
  customerLastName: string;
}
const Gratuity: React.FC<CustomerData> = () => {
  const [appointmentDate, setAppointmentDate] = useState<string>('');
  const [appointmentPrice, setAppointmentPrice] = useState<string>('');
  const [appointmentTip, setAppointmentTip] = useState<number>(0);
  const [appointmentServiceFee, setAppointmentServiceFee] = useState<string>('');
  const [appointmentTax, setAppointmentTax] = useState<string>('');
  const [appointmentServicesTotal, setAppointmentServicesTotal] = useState<string>('');
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [customerAddressLineOne, setCustomerAddressLineOne] =
    useState<string>('');
  const [customerAddressLineTwo, setCustomerAddressLineTwo] =
    useState<string>('');
  const [customerFirstName, setCustomerFirstName] = useState<string>('');
  const [customerLastName, setCustomerLastName] = useState<string>('');
  const [customerId, setCustomerId] = useState<number>(null);
  const [appointmentId, setAppointmentId] = useState<number>(null);
  const [teamMemberIds, setTeamMemberIds] = useState<any>([]);
  const [teamID, setTeamId] = useState<number>();

  const [franchiseeName, setFranchiseeName] = useState<string>('');
  const [franchiseeState, setFranchiseeState] = useState<string>('');
  const [franchisee, setFranchisee] = useState<any>(null);
  const [appointmentExpired, setAppointmentExpired] = useState<boolean>(false);
  const [appointmentMoreThanSevenDays, setAppointmentMoreThanSevenDays] =
    useState<boolean>(false);
  const [submittedTipAmount, setSubmittedTipAmount] = useState<number>(0);
  const [customerData, setCustomerData] = useState<any>({});
  const [creditCardSubmitted, setCreditCardSubmitted] =
    useState<boolean>(false);
  const [appointmentCharged, setAppointmentCharged] = useState<boolean>(false);
  const [appointmentPaid, setAppointmentPaid] = useState<boolean>(false);
  const [showCreditCardField, setShowCreditCardField] =
    useState<boolean>(false);

  const [vaultID, setVaultID] = useState<string>('');
  const [collectJsToken, setCollectJsToken] = useState<string>('');

  const [creditCardAction, setCreditCardAction] = useState<string>('');

  const [appointmentPackageId, setAppointmentPackageId] =
    useState<number>(null);

  const [isChecked, setIsChecked] = useState<boolean>(true);

  const [showErrorToast, setShowErrorToast] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  // const [customerZipCode, setCustomerZipCode] = useState<string>('');

  const router = useRouter();
  let db = database.app.database('https://maid-dashboard.firebaseio.com/');

  const getDaysInBetween = (cleaningDate) => {
    const currentTime = new Date();
    var start = moment(currentTime, 'YYYY-MM-DD');
    var end = moment(cleaningDate, 'YYYY-MM-DD');
    console.log(start);
    console.log(end);
    let diff = moment.duration(end.diff(start)).asDays();
    console.log(diff);
    return diff;
  };

  useEffect(() => {
    const url = window.location.href;
    const splitUrl = url.split('gratuity/')[1];
    const encryptedMessage = splitUrl.split('==')[0] + '==';
    const secretKey = splitUrl.split('==')[1];
    axios
      .post('/api/get-customer-from-appointment/', {
        baseMessage: encryptedMessage,
        key: secretKey,
      })
      .then((data: any) => {
        const customer_info = data.data.customer_info;
        let d = new Date(customer_info.appointmentDate);
        let year = d.getFullYear();
        let month = (1 + d.getMonth()).toString().padStart(2, '0');
        let day = d.getDate().toString().padStart(2, '0');
        const diffDays = getDaysInBetween(d);
        if (diffDays > 8) {
          setAppointmentMoreThanSevenDays(true);
        }
        if (diffDays < -7) {
          setAppointmentExpired(true);
        }
        setAppointmentDate(month + '/' + day + '/' + year);
        setAppointmentPrice(customer_info.appointmentPrice);
        setAppointmentServiceFee(customer_info.appointmentServiceFee);
        setAppointmentTax(customer_info.appointmentTax);
        setAppointmentServicesTotal(customer_info.appointmentServicesTotal);
        setCustomerAddressLineOne(customer_info.customerAddressLineOne);
        setCustomerAddressLineTwo(customer_info.customerAddressLineTwo);
        setCustomerFirstName(customer_info.customerFirstName);
        setCustomerLastName(customer_info.customerLastName);
        setCustomerId(customer_info.customerId);
        setFranchiseeState(customer_info.franchiseeState);
        setFranchiseeName(customer_info.franchiseeName);
        setAppointmentTip(Number(customer_info.appointmentTip));
        setAppointmentId(Number(customer_info.appointmentId));
        setVaultID(customer_info.customerVault_id);
        setAppointmentCharged(customer_info.appointmentCharged);
        setAppointmentPaid(customer_info.appointmentPaid);
        setAppointmentPackageId(customer_info.appointmentPackageId);
        setTeamMemberIds(customer_info.employeeIDs);
        setTeamId(customer_info.teamID);
        setTotalPrice(Number(customer_info.appointmentPrice) + Number(customer_info.appointmentServiceFee) + Number(customer_info.appointmentTax) + Number(customer_info.appointmentServicesTotal));
        
        setCustomerData({
          firstName: customer_info.customerFirstName,
          lastName: customer_info.customerLastName,
          addressLineOne: customer_info.customerAddressLineOne,
          addressLineTwo: customer_info.customerAddressLineTwo,
          city: customer_info.customerCity,
          state: customer_info.franchiseeState,
          zipCode: customer_info.customerZipCode,
          phonePrimary: customer_info.customerPhonePrimary,
          email: customer_info.customerEmail,
          franchiseeSlug: customer_info.franchiseeSlug,
          vaultId: customer_info.customerVault_id || null,
          shippingAddressOne: customer_info.customerAddressLineOne,
          shippingAddressTwo: customer_info.customerAddressLineTwo,
          shippingCity: customer_info.customerAddressLineTwo,
          shippingZipCode: customer_info.customerZipCode,
          shippingState: customer_info.franchiseeState,
          teamMemberIds: customer_info.employeeIDs,
        });
        try {
          datadogRum.setUser({
            name: `${customer_info.customerFirstName} ${customer_info.customerLastName}`,
            email: customer_info.customerEmail,
          });
        } catch (error) {
          console.log(error)
        }
        axios
          .post('/api/get-locations/')
          .then(async (res) => {
            let result = res.data.data.find(
              (franchise) => franchise.slug === customer_info.franchiseeSlug
            );
            if (result === undefined) return;
            console.log({ result });
            setFranchisee(result);
            setCollectJsToken(result.franchisee_preferences.collectJsToken);
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
        router.push('/404/');
        Sentry.captureException(e);
      });

 
  }, []);

  const tipSubmitted = (amount) => {
    setSubmittedTipAmount(Number(amount));
  };
  const submitCreditCard = (collectJsVaultId) => {
    if (creditCardAction === 'creditCard') {
      axios
        .post('/api/charge-cc-gratuity/', {
          tip: Number(submittedTipAmount),
          id: appointmentId,
          customer: customerId,
          vaultId: Number(collectJsVaultId),
          futureTip: isChecked,
        })
        .then((res) => {
          if (res.data.message.includes('Failed')) {
            setShowErrorToast(true);
            Sentry.captureException(res.data.message);
            setErrorMessage(res.data.message);
          } else {
            setCreditCardSubmitted(true);
            const onlineUserReference = db.ref(
              `/appointments/${appointmentId}`
            );

            onlineUserReference.set({
              appointmentId: appointmentId,
              teamMemberIds: teamMemberIds,
              tipAmount: Number(submittedTipAmount) / teamMemberIds.length,
              created: firebase.database.ServerValue.TIMESTAMP,
            });
          }
        })
        .catch((err) => {
          Sentry.captureException(err);

          console.log(err);
        });
      // setCreditCardSubmitted(true);
    } else if (creditCardAction === 'appointment') {
      axios
        .post('/api/set-request-notification-tip/', {
          tip: Number(submittedTipAmount),
          id: appointmentId,
          customer: customerId,
          futureTip: isChecked,
        })
        .then((res) => {
          console.log(res);
          const onlineUserReference = db.ref(`/appointments/${appointmentId}`);

          onlineUserReference.set({
            appointmentId: appointmentId,
            teamMemberIds: teamMemberIds,
            tipAmount: Number(submittedTipAmount) / teamMemberIds.length,
            created: firebase.database.ServerValue.TIMESTAMP,
          });
        })
        .catch((err) => {
          console.log(err);
          Sentry.captureException(err);
        });
      setCreditCardSubmitted(true);
    }
  };
  const handleShowCreditCard = (action) => {
    setCreditCardAction(action);
    setShowCreditCardField(true);
  };

  const handleIsChecked = () => {
    setIsChecked(!isChecked);
  };

  const handleErrorToast = () => {
    setShowErrorToast(true);
  };

  return (
    <>
      {customerFirstName && (
        <FranchiseeProvider franchiseeValue={franchisee}>
          <Layout alternateFooter>
            <Head
              slug='gratuity'
              title='Gratuity | Two Maids '
              description='See why Two Maids  is a Maid Service worth talking about!'
            />
            <OpenGraphTitle
              title={`Gratuity | Two Maids ${franchiseeName}`}
            />
            <OpenGraphDescription>
              {/* Add About description here */}
              {`Gratuity | Two Maids  ${franchiseeName}`}
            </OpenGraphDescription>

            <div
              className='test'
              style={{ minHeight: '100vh', overflow: 'scroll' }}
            >
              <Section>
                <ToastWrapper>
                  <Toast
                    show={showErrorToast}
                    onClose={() => setShowErrorToast(false)}
                    autohide
                    delay={5000}
                  >
                    <Toast.Body
                      className='toast-error'
                      style={{ background: '#dc3545' }}
                    >
                      {errorMessage}
                    </Toast.Body>
                  </Toast>
                </ToastWrapper>
                <Row className='justify-content-center mt-2'>
                  <Col xs={12} md={10} lg={8} className='mt-2'>
                    <h1
                      className='h1 text-center text-capitalize mb-4'
                      style={{ color: '#d4367f' }}
                    >
                      Hello, {customerFirstName}
                    </h1>
                    {!appointmentExpired &&
                      appointmentTip <= 0 &&
                      !appointmentMoreThanSevenDays && (
                        <div>
                          <h1 className='h2 text-center mb-5'>
                            Glad you enjoyed our service in{' '}
                            <span style={{ color: '#d3377f' }}>
                              {franchiseeName}, {franchiseeState}!
                            </span>
                          </h1>

                          <p
                            className='mb-5 text-center'
                            style={{ fontSize: '1.2rem', lineHeight: '30px' }}
                          >
                            We are thrilled to know you enjoyed our cleaning
                            service on{' '}
                            <span
                              style={{ color: '#d3377f', fontWeight: 'bold' }}
                            >
                              {appointmentDate.split('T')[0]}
                            </span>
                            ! We appreciate you leaving a tip for your
                            hardworking PHC's and wish to serve you again!
                          </p>

                          <div
                            id='booking-form-confirmation'
                            className='mt-0 mb-10 px-2'
                          >
                            {submittedTipAmount <= 0 ? (
                              <>
                                <GratuitySelection
                                  price={appointmentPrice}
                                  totalPrice={totalPrice}
                                  customerId={customerId}
                                  appointmentId={appointmentId}
                                  tipSubmitted={tipSubmitted}
                                  appointmentPaid={appointmentPaid}
                                  appointmentCharged={appointmentCharged}
                                  vaultID={vaultID}
                                  handleShowCreditCard={handleShowCreditCard}
                                  appointmentPackageId={appointmentPackageId}
                                  handleIsChecked={handleIsChecked}
                                  handleErrorToast={handleErrorToast}
                                  customerData={customerData}
                                />
                              </>
                            ) : (
                              <div>
                                {vaultID && !showCreditCardField && (
                                  <h4 style={{ textAlign: 'center' }}>
                                    Thank you for your submission!
                                  </h4>
                                )}
                                {!vaultID &&
                                  !creditCardSubmitted &&
                                  appointmentCharged === false &&
                                  appointmentPaid === true && (
                                    <h4 style={{ textAlign: 'center' }}>
                                      Please enter credit card information.
                                    </h4>
                                  )}
                                {creditCardSubmitted && (
                                  <h4 style={{ textAlign: 'center' }}>
                                    Thank you for your submission!
                                  </h4>
                                )}
                              </div>
                            )}
                            {showCreditCardField &&
                              !creditCardSubmitted &&
                              collectJsToken && (
                                <PaymentProvider>
                                  <BookingPaymentGratuity
                                    franchisee={franchisee}
                                    customerData={customerData}
                                    submittedTipAmount={submittedTipAmount}
                                    submitCreditCard={submitCreditCard}
                                    collectJsToken={collectJsToken}
                                  />
                                </PaymentProvider>
                              )}
                          </div>
                        </div>
                      )}
                    {!appointmentExpired &&
                      !appointmentMoreThanSevenDays &&
                      appointmentTip > 0 && (
                        <div style={{ textAlign: 'center' }}>
                          <p style={{ marginBottom: '1rem', fontSize: '22px' }}>
                            It seems you have already tipped{' '}
                            <span style={{ fontWeight: 'bold' }}>
                              ${appointmentTip}
                            </span>{' '}
                            for this cleaning.
                          </p>
                          <p style={{ fontSize: '18px' }}>
                            Thank you for your generous tip.
                          </p>
                          <p style={{ fontSize: '18px' }}>
                            We hope to serve you again soon!
                          </p>
                          <Button
                            style={{ padding: '12px 30px', marginTop: '30px' }}
                            className='gratuity-button'
                          >
                            <Link href='/' prefetch={false} passHref>
                              <a
                                className=''
                              >
                                <span className=''>Back To Home Page</span>
                              </a>
                            </Link>
                          </Button>
                        </div>
                      )}
                    {appointmentExpired && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          textAlign: 'center',
                        }}
                      >
                        <h4>Your tip submission has expired</h4>
                        <p
                          style={{
                            marginBottom: '0px',
                            marginTop: '0.5rem',
                            fontSize: '18px',
                          }}
                        >
                          It has been 7 days since your cleaning.
                        </p>
                        <p
                          style={{
                            marginBottom: '0px',
                            marginTop: '0.5rem',
                            fontSize: '18px',
                          }}
                        >
                          Tipping for this cleaning is no longer available.
                        </p>
                        <Button
                          style={{ padding: '12px 30px', marginTop: '30px' }}
                          className='gratuity-button'

                        >
                          <Link href='/' prefetch={false} passHref>
                            <a
                              className=''
                            >
                              <span className=''>Back To Home Page</span>
                            </a>
                          </Link>
                        </Button>
                      </div>
                    )}
                    {appointmentMoreThanSevenDays && (
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column',
                          textAlign: 'center',
                          marginTop: '45px',
                        }}
                      >
                        <h3 style={{ marginBottom: '15px' }}>
                          Your cleaning has not begun.
                        </h3>
                        <p
                          style={{ fontSize: '18px', marginBottom: '5px 0px' }}
                        >
                          Your cleaning is scheduled for{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {appointmentDate}.
                          </span>{' '}
                        </p>
                        <p style={{ fontSize: '18px' }}>
                          Please revisit this link after your cleaning has been
                          completed.
                        </p>
                        <Button
                          style={{ padding: '12px 30px', marginTop: '30px' }}
                          className='gratuity-button'

                        >
                          <Link href='/' prefetch={false} passHref>
                            <a
                              className=''
                            >
                              <span className=''>Back To Home Page</span>
                            </a>
                          </Link>
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
              </Section>
            </div>
            )
            <div className='icon__kitchen'>
              <Container className='position-relative'>
                {/* <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconKitchen} title='A clean kitchen' /> */}
              </Container>
            </div>
            <ContextComponent franchisee={franchisee} />
          </Layout>
        </FranchiseeProvider>
      )}
    </>
  );
};

export default Gratuity;
